<template functional>
  <input
    type="checkbox"
    @click="(e) => $options.Executing(e, props, data)"
    class="el-checkbox el-checkbox__input el-checkbox__inner"
    :value="data.attrs.row.Excetuted"
  />
</template>

<script>
//import { render } from 'nprogress'
/*
   function Executing () {
    console.log("Executing");
   }*/
//data.attrs.row.Excetuted

export default {
  name: "CheckboxCellColumn",
  //Value : Boolean,
  Executing(event, props, data) {
    data;
    //console.log("attrs: " , props, "\n data: ", data, "\n event: ", event /*, "\n event value: ", document.getElementById("functCheckBox").checked*/);
    props.row[props.column] = event.target.checked;
    //console.log("Executing");
    props.openDrawer();
  }
  /*
    functional: true,

    render: function (createElement, context) {
        let element

        element = createElement(
            'input', 
            {
                attrs: {

                }
            }
        )
    }*/
  // Executing
};
</script>

<style></style>
